export default (url, store) => {
		if (!url) return url;
    return url.replace('/original/', `/${store}/`)
}